/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_AllowInputs */

const cs_listing_portals_allow = /** @type {(inputs: Listing_Portals_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Povolit na nemovitostech`)
};

const en_listing_portals_allow = /** @type {(inputs: Listing_Portals_AllowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow on properties`)
};

/**
* | output |
* | --- |
* | "Allow on properties" |
*
* @param {Listing_Portals_AllowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_allow = /** @type {((inputs?: Listing_Portals_AllowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_AllowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_allow(inputs)
	return cs_listing_portals_allow(inputs)
});